/**
 * @generated SignedSource<<bf18ba2506ce9901171044c808861e0f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignTemplateToMarketingEmailInput = {
  emailTemplateIdentifier?: string | null | undefined;
  id: string;
};
export type MarketingEmailDetailsViewAssignTemplateMutation$variables = {
  input: AssignTemplateToMarketingEmailInput;
};
export type MarketingEmailDetailsViewAssignTemplateMutation$data = {
  readonly assignTemplateToMarketingEmail: {
    readonly emailTemplate: {
      readonly emailLayout: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly emailTemplateIdentifier: string;
      readonly id: string;
      readonly name: string;
      readonly variants: ReadonlyArray<{
        readonly language: string;
        readonly preheader: string | null | undefined;
        readonly subject: string | null | undefined;
      }>;
    } | null | undefined;
    readonly id: string;
  };
};
export type MarketingEmailDetailsViewAssignTemplateMutation = {
  response: MarketingEmailDetailsViewAssignTemplateMutation$data;
  variables: MarketingEmailDetailsViewAssignTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarketingEmail",
    "kind": "LinkedField",
    "name": "assignTemplateToMarketingEmail",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailTemplate",
        "kind": "LinkedField",
        "name": "emailTemplate",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailTemplateIdentifier",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailTemplateVariant",
            "kind": "LinkedField",
            "name": "variants",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subject",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preheader",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailLayout",
            "kind": "LinkedField",
            "name": "emailLayout",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarketingEmailDetailsViewAssignTemplateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarketingEmailDetailsViewAssignTemplateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d095d9050ebc1a689f43a06eff0a0b21",
    "id": null,
    "metadata": {},
    "name": "MarketingEmailDetailsViewAssignTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation MarketingEmailDetailsViewAssignTemplateMutation(\n  $input: AssignTemplateToMarketingEmailInput!\n) {\n  assignTemplateToMarketingEmail(input: $input) {\n    id\n    emailTemplate {\n      id\n      emailTemplateIdentifier\n      name\n      variants {\n        language\n        subject\n        preheader\n      }\n      emailLayout {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "159e7dc38b9f7b2d04da8e0cf462c95e";

export default node;
